const mutations = {
    setFollowingEntries(state, entries) {
        state.followingEntries = entries
    },
    setFeaturedEntries(state, entries) {
        state.featuredEntries = entries
    },
    addFeaturedEntries(state, entries) {
        state.featuredEntries.push(...entries)
    },
    addFollowingEntries(state, entries) {
        state.followingEntries.push(...entries)
    },
    setAllEntries(state, entries) {
        state.allEntries = entries
    },
    addAllEntries(state, entries) {
        state.allEntries.push(...entries)
    },
    setUserDrafts(state, drafts) {
        state.drafts = drafts
    },
    addUserDrafts(state, drafts) {
        state.drafts.push(...drafts)
    },
    setUserArtworks(state, userArtworks) {
        state.userArtworks = userArtworks
    },
    addUserArtworks(state, userArtworks) {
        state.userArtworks.push(...userArtworks)
    },
    setCurrentArtwork(state, currentArtwork) {
        state.currentArtwork = currentArtwork
    },
    followingEntriesReachedBottom(state, value) {
        state.followingEntriesReachedBottom = value
    },
    allEntriesReachedBottom(state, value) {
        state.allEntriesReachedBottom = value
    },
    featuredEntriesReachedBottom(state, value) {
        state.featuredEntriesReachedBottom = value
    },
    userEntriesReachedBottom(state, value) {
        state.userEntriesReachedBottom = value
    },
    userDraftsReachedBottom(state, value) {
        state.userDraftsReachedBottom = value
    }
}

export default mutations